'use client'

import React from 'react'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

export const FooterLinkClient = ({
    href,
    children,
    className
}: {
    href: string;
    children: React.ReactNode;
    className?: string
}) => {
    const pathname = usePathname()

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        // Normalize paths for comparison (remove trailing slashes)
        const normalizedPathname = pathname?.replace(/\/$/, '') || ''
        const normalizedHref = href.replace(/\/$/, '')

        if (normalizedPathname === normalizedHref) {
            e.preventDefault()
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }

    return (
        <Link href={href} className={className} onClick={handleClick}>
            {children}
        </Link>
    )
}
